import type { OrgStyling } from '~/services/styling.server'
import type { CSSProperties } from 'react'

const RADIUS: Record<OrgStyling['cardBorderRadius'], string> = {
  none: '0px',
  sm: '0.125rem',
  md: '0.375rem',
  lg: '0.5rem',
  xl: '0.75rem'
}

/**
 * Zet tenant-styling éénmalig om naar CSS custom properties (--ws-*).
 * Wordt op de root van de webshop-layout gezet zodat alle componenten
 * tenant-kleuren via Tailwind var-utilities kunnen gebruiken
 * (bv. bg-(--ws-surface)) i.p.v. inline styles en JS-hover-handlers.
 */
export function stylingToCssVars(s: OrgStyling): CSSProperties {
  return {
    '--ws-bg': `#${s.backgroundColor}`,
    '--ws-surface': `#${s.backgroundColorHighlight}`,
    '--ws-surface-2': `#${s.backgroundColorSecondary}`,
    '--ws-border': `#${s.borderColor}`,
    '--ws-heading': `#${s.headingColor}`,
    '--ws-text': `#${s.textColorPrimary}`,
    '--ws-text-muted': `#${s.textColorSecondary}`,
    '--ws-link': `#${s.linkColor}`,
    '--ws-link-hover': `#${s.linkColorHover}`,
    '--ws-accent': `#${s.accentColor}`,
    '--ws-success': `#${s.successColor}`,
    '--ws-btn-bg': `#${s.primaryButtonBg}`,
    '--ws-btn-bg-hover': `#${s.primaryButtonBgHover}`,
    '--ws-btn-bg-done': `#${s.primaryButtonBgDone}`,
    '--ws-btn-text': `#${s.primaryButtonText}`,
    '--ws-btn2-bg': `#${s.secondaryButtonBg}`,
    '--ws-btn2-bg-hover': `#${s.secondaryButtonBgHover}`,
    '--ws-btn2-text': `#${s.secondaryButtonText}`,
    '--ws-header-bg': `#${s.headerBgColor}`,
    '--ws-header-text': `#${s.headerTextColor}`,
    '--ws-footer-bg': `#${s.footerBgColor}`,
    '--ws-footer-text': `#${s.footerTextColor}`,
    '--ws-footer-border': `#${s.footerBorderColor}`,
    '--ws-radius': RADIUS[s.cardBorderRadius]
  } as CSSProperties
}
